import React from "react";
import { SectionHeader } from "@/sections/Services";
import { Calendar, Layers, Smartphone, Target, Zap } from "lucide-react";

const REASONS = [
  {
    icon: Calendar,
    title: "Trading since 2019",
    copy: "Six years of building, shipping and supporting digital products for UK businesses.",
  },
  {
    icon: Layers,
    title: "SME-led experience",
    copy: "Hands-on with real, practical sectors — gyms, cafés, accountants, law firms, hospitality.",
  },
  {
    icon: Smartphone,
    title: "Web, mobile & product",
    copy: "Full-spectrum capability across websites, apps, SaaS, internal systems and AI products.",
  },
  {
    icon: Target,
    title: "Usability & business value",
    copy: "Strong focus on outcomes that matter — clarity, conversion, retention and operational lift.",
  },
  {
    icon: Zap,
    title: "Idea to prototype, fast",
    copy: "Built to move quickly, with the discipline to scale beyond the prototype phase.",
  },
];

export default function WhyUs() {
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="relative py-24 md:py-32 border-t border-white/[0.06]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <SectionHeader
          eyebrow="Why Mackbe Tech"
          title="Why work with Mackbe Tech?"
          subtitle="A practical technology partner — confident, capable and easy to work with."
        />

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {REASONS.map((r, i) => {
            const Icon = r.icon;
            const span =
              i === 0 ? "lg:col-span-2" : i === 4 ? "lg:col-span-2" : "";
            return (
              <div
                key={r.title}
                data-testid={`reason-${i}`}
                className={`mk-reveal mk-card rounded-2xl p-7 md:p-8 ${span}`}
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 bg-white/[0.04]">
                  <Icon className="h-5 w-5 text-[#00D4FF]" />
                </div>
                <h3 className="mt-6 font-display text-xl md:text-2xl tracking-tight text-white">
                  {r.title}
                </h3>
                <p className="mt-2 text-[15px] text-slate-400 leading-relaxed max-w-md">
                  {r.copy}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
